import React from 'react';
import Waypoint from 'react-waypoint';

import Footer from '../components/Footer';
import Layout from '../components/Layout';

import SlidesVideo from '../components/home/SlidesVideo';
import Learning from '../components/home/Learning';
import Difference from '../components/home/Difference';
import News from '../components/home/News';
import IBPYP from '../components/home/IBPYP';
import ISO9001 from '../components/home/ISO9001';
import Apply from '../components/home/Apply';

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    fixedHeader: false,
  };

  render() {
    const { locale } = this.props;
    const { fixedHeader } = this.state;

    return (
      <Layout locale={locale} showHeader fixedHeader={fixedHeader}>
        <SlidesVideo locale={locale} />

        <Waypoint
          onEnter={() => this.setState({ fixedHeader: false })}
          onLeave={() => this.setState({ fixedHeader: true })}
        />

        <Learning locale={locale} />
        <Difference locale={locale} />
        <News locale={locale} />
        <IBPYP locale={locale} />
        <ISO9001 locale={locale} />
        <Apply locale={locale} />
        <Footer locale={locale} />
      </Layout>
    );
  }
}
